(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/start-subscription/assets/javascripts/behaviors/changesubscription.js') >= 0) return;  svs.modules.push('/components/tur/start-subscription/assets/javascripts/behaviors/changesubscription.js');
"use strict";


(function (Backbone, _, svs) {
  'use strict';

  svs.tur.start_subscription.behaviors.ChangeSubscription = svs.tur.start_subscription.behaviors.Subscription.extend({
    CONSTANTS: svs.tur.start_subscription.constants,
    options() {
      return {
        entryModel: new svs.tur.start_subscription.models.ChangeEntry(),
        prefix: 'change'
      };
    },
    onChangeSubscription(_ref) {
      let entry = _ref.entry,
        options = _ref.options,
        _ref$cancelUrl = _ref.cancelUrl,
        cancelUrl = _ref$cancelUrl === void 0 ? null : _ref$cancelUrl;
      const internalCancelUrl = cancelUrl ? svs.utils.url.makeInternal(cancelUrl, svs.core.urlMapping.get('myGamingsSubscriptions')) : null;
      this.entryModel.reset();
      this.entryModel.set({
        subscriptionEntry: entry,
        subscriptionOptions: options,
        subscriptionId: entry.subscriptionIdRef,
        cancelUrl: internalCancelUrl
      });
      this.verifyUser();
    },
    onChangeIsVerified() {
      this.getEntryOrAnnouncement();
    },
    onChangeSubscriptionDefined() {
      this.view.triggerMethod('saveTrackingFromWager', this, () => this.triggerPrefixMethod('activationSuccess', {
        triggerView: true
      }));
    },
    onChangeActivationSuccess() {
      this.pollNewSubscription(async function () {
        const subEntry = await svs.tur.start_subscription.utils.getSubEntryFromContextOrLocalStorage(this);
        window.location.href = svs.tur.start_subscription.utils.afterSubPayRedirectUrl(subEntry, this.entryModel.get('newSubId'), true);
      });
    },
    verifySpendLimit(proceed) {
      const _this$entryModel$attr = this.entryModel.attributes,
        amount = _this$entryModel$attr.amount,
        subscriptionId = _this$entryModel$attr.subscriptionId; 
      if (amount && svs.core.detect.feature('ft-omni-3-ktt')) {
        svs.tur.start_subscription.radio.request('checkSpendLimitRenewal', amount, subscriptionId, this, proceed, 'change');
      } else {
        proceed();
      }
    },
    onChangeShowConfirmSubscription() {
      const onCancel = () => {
        const cancelUrl = this.entryModel.get('cancelUrl');
        if (cancelUrl) {
          svs.components.loader.show();
          svs.utils.url.navigate(cancelUrl);
        }
      };
      const proceed = () => {
        const autoPostNewSubscription = svs.utils.paramHandler.get({
          key: 'apns'
        }).value;
        if (autoPostNewSubscription === true || autoPostNewSubscription === 'true') {
          svs.utils.paramHandler.remove({
            key: 'apns'
          });
          svs.components.loader.show();
          this.postNewSubscription();
          return;
        }
        const _this$getDialogChange = this.getDialogChangeConfirmMessage(),
          title = _this$getDialogChange.title,
          message = _this$getDialogChange.message;
        const dialog = new svs.ui.dialog.Confirm({
          branding: svs.ui.dialog.branding.TUR,
          icon: 'subscription',
          title,
          message,
          actions: [{
            title: 'Avbryt',
            callback: () => {
              dialog.close();
              onCancel();
            }
          }, {
            title: 'Ändra',
            callback: () => {
              dialog.close();
              svs.components.loader.show();
              this.postNewSubscription();
            }
          }]
        });
        svs.ui.dialog.api.add(dialog);
      };
      this.verifySpendLimit(proceed, onCancel);
    },
    getMondayDateOfWeekWith15thAfterPayMonth(payMonth) {
      const today = new Date();
      const year = today.getFullYear();

      const fifteenth = new Date(year, payMonth, 15);

      const dayOfWeek = dateFns.getDay(fifteenth); 
      const diffToMonday = (dayOfWeek + 6) % 7;
      return dateFns.subDays(fifteenth, diffToMonday);
    },
    getDialogChangeConfirmMessage() {
      const payTime = this.entryModel.attributes.payTime;
      const payMonth = dateFns.format(dateFns.parseISO(payTime), 'M');
      const product = this.entryModel.attributes.subscriptionOptions.product;
      let nextGameDate;
      if (product.toLowerCase() === 'lyckoplatsen') {
        nextGameDate = this.getMondayDateOfWeekWith15thAfterPayMonth(payMonth);
      } else {
        const nextMonthDate = dateFns.addMonths(dateFns.parseISO(payTime), 1);
        nextGameDate = dateFns.setDate(nextMonthDate, 15);
      }
      const nextGameString = dateFns.format(nextGameDate, 'd/M');
      const payTimeString = svs.utils.date.FormatTime('d/M', payTime);
      return {
        title: "Vill du \xE4ndra din prenumeration p\xE5 ".concat(product, "?"),
        message: [{
          type: svs.ui.dialog.message.TEXT,
          text: "\xC4ndringen b\xF6rjar g\xE4lla vid n\xE4sta betalning som sker den ".concat(payTimeString, ". N\xE4sta spel med dina \xE4ndringar sker d\xE4refter fr\xE5n och med den ").concat(nextGameString, "."),
          align: svs.ui.dialog.message.align.CENTER
        }, {
          type: svs.ui.dialog.message.TEXT,
          text: "Spel som redan \xE4r betalda l\xF6per p\xE5 fram tills dess med dina tidigare val.",
          align: svs.ui.dialog.message.align.CENTER
        }]
      };
    }
  });
})(Backbone, _, svs);

 })(window);